import React, {useState, useEffect} from 'react';
import {faCheckSquare, faSquare} from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// import "./GrantCaptureModal.css";
import {Pagination} from "../../../../common/table/pagination/Pagination";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";

export const GrantCaptureModal = ({staffMemberList, setStaffMemberList, onUpdateClick}) => {

    const [staffMemberPages, setStaffMemberPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        let copyOfStaffMemberList = JSON.parse(JSON.stringify(staffMemberList));
        const pages = [];
        while (copyOfStaffMemberList.length) {
            pages.push(copyOfStaffMemberList.splice(0, 7));
        }
        setStaffMemberPages([...pages]);
    }, [staffMemberList]);


    const handleStaffMemberClick = (selectedStaffMember) => {
        const copyOfStaffMemberList = JSON.parse(JSON.stringify(staffMemberList));
        copyOfStaffMemberList.forEach((staffMember) => {
            if (staffMember.externalReference === selectedStaffMember.externalReference) {
                staffMember.isSelected = !staffMember.isSelected;
            }
        });
        setStaffMemberList([...copyOfStaffMemberList]);
    }

    const buildList = () => {
        return staffMemberPages[currentPage].map((staffMember) => {
            return (
                <div className="capture-modal-list-item" key={staffMember.externalReference}>
                    <div className="capture-modal-list-item-text">{staffMember.firstName + " " + staffMember.lastName}</div>
                    <div className="capture-modal-list-item-icon-container">
                        {staffMember.isSelected &&
                        <FontAwesomeIcon className="capture-modal-list-item-icon" icon={faCheckSquare}
                                         onClick={() => {
                                             handleStaffMemberClick(staffMember)
                                         }}/>}
                        {!staffMember.isSelected &&
                        <FontAwesomeIcon className="capture-modal-list-item-icon" icon={faSquare}
                                         onClick={() => {
                                             handleStaffMemberClick(staffMember)
                                         }}/>}
                    </div>
                </div>
            );
        });
    }

    let listItems;
    if (staffMemberPages.length > 0) {
        listItems = buildList();
    }

    return (
        <div className="capture-modal-container">
            <div className="capture-modal-list-header-container">
                <p className="capture-modal-list-header-one">Staff Member</p>
                <p className="capture-modal-list-header-two">Selected</p>
            </div>
            <div className="capture-modal-list-items-container">
                {listItems}
            </div>
            <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage}
                        pageCount={staffMemberPages.length}/>
            <div className="capture-modal-button-container">
                <StandardButton text="Update Staff" onClick={onUpdateClick}/>
            </div>
        </div>
    );
}
